export default "__VITE_PUBLIC_ASSET__d22a17b1__"